{
  "invite": {
    "pageTitle": "邀請",
    "hi": "{{name}}，您好！",
    "hiNoName": "您好！",
    "intro": "歡迎使用我們提供的雲端 Isaac Sim 來協助您完成作業。",
    "brief": "作業說明",
    "facts": {
      "gpu": "您有 {{hours}} 小時的機器使用時間",
      "gpuHelp": "只有當機器運行且 工作區 就緒時才會計算使用時間，您可以暫停機器來停止計時。",
      "window": "首次啟動後，您有 {{days}} 天時間來使用機器",
      "windowHelp": "在期限內，您可以自由啟動、暫停或繼續使用機器，但仍有機器使用時間限制，請自行安排時間。",
      "files": "檔案不會永久保留",
      "filesHelp": "請自行保存需要的檔案。我們審閱後刪除機器時，機器上的檔案也會一併刪除。",
      "gpuRemaining": "機器使用時間還剩 {{time}}",
      "deadlineHelp": "請留意剩餘的機器使用時間，並在截止時間前完成作業。再次啟動不會重設期限。",
      "earliest": "存取權限會在最早啟用的時間限制到期時結束。暫停 GPU 不會暫停作業期限或連續作答計時。"
    },
    "email": "登入信箱",
    "emailHelp": "驗證碼只會寄到這個信箱。",
    "sendCode": "寄送登入驗證碼給我",
    "sending": "寄送中…",
    "turnstileWait": "正在檢查您的瀏覽器…",
    "error": {
      "expired": {
        "title": "此邀請已過期",
        "body": "邀請連結有時效。HR 可以重新發送新的連結。"
      },
      "revoked": {
        "title": "此邀請已撤回",
        "body": "此連結已無法進入作業。"
      },
      "finished": {
        "title": "此 session 已結束",
        "body": "您的 session 已經完成，感謝您。"
      },
      "window_over": {
        "title": "評測期限已結束",
        "body": "作業期限已過。如需更多時間，請聯絡 HR。"
      },
      "invalid": {
        "title": "此連結無效",
        "body": "請確認您開啟的是 HR 提供的完整連結。"
      },
      "locked": {
        "title": "邀請連結已停用",
        "body": "驗證碼輸入錯誤次數已達上限。請透過現有的電子郵件對話聯絡 HR，索取新的邀請連結。"
      },
      "sendFailed": "無法寄送驗證碼，請稍後再試。"
    },
    "gpuIntro": "歡迎！請使用雲端 GPU 工作區與 VS Code 完成作業。"
  },
  "verify": {
    "pageTitle": "登入",
    "title": "輸入登入驗證碼",
    "sentTo": "我們已將 6 位數驗證碼寄到 {{email}}。",
    "orLink": "或直接點擊信中的連結登入。",
    "spam": "沒收到？請檢查垃圾郵件。驗證碼有效 10 分鐘。",
    "codeLabel": "6 位數驗證碼",
    "digit": "第 {{n}} 位",
    "verifying": "驗證中…",
    "resend": "重新寄送驗證碼",
    "resendIn": "重新寄送驗證碼（{{seconds}} 秒）",
    "resent": "新的驗證碼已寄出。",
    "attemptsLeft": "還可嘗試 {{count}} 次",
    "attemptsLeft_one": "還可嘗試 {{count}} 次",
    "noInvite": "請重新開啟 HR 提供的邀請連結以索取驗證碼。",
    "error": {
      "code_invalid": "驗證碼不正確。",
      "code_expired": "驗證碼已過期，請重新索取。",
      "code_burned": "錯誤次數過多。請重新開啟邀請連結並索取新的驗證碼。",
      "magic_invalid": "此登入連結已失效。請輸入信中的驗證碼，或重新索取。",
      "turnstile_failed": "瀏覽器檢查失敗，請重新載入頁面再試。"
    }
  },
  "consent": {
    "pageTitle": "隱私權同意書",
    "title": "隱私權同意書",
    "version": "版本 {{version}} · 生效日 {{date}}",
    "agree": "我同意依《隱私協議》所述方式蒐集、處理及利用我的個人資料。",
    "otherLanguage": "以{{lang}}閱讀",
    "intro": "請查看隱私權同意書，並確認您的選擇以繼續進入工作區。",
    "readAgreement": "閱讀完整隱私權同意書（在新分頁開啟）",
    "updated": "隱私權同意書已更新。請查看最新版本，並重新勾選同意。",
    "continue": "繼續"
  },
  "app": {
    "pageTitle": "工作區",
    "gpuLeft": "機器剩餘使用時間",
    "deadline": "截止時間",
    "deadlineBeforeLaunch": "自首次啟動起 5 天",
    "deadlineBeforeLaunchDays": "自首次啟動起 {{days}} 天",
    "menu": {
      "signedInAs": "登入身分",
      "language": "語言",
      "logout": "登出"
    },
    "status": {
      "ready": {
        "title": "您的機器已可啟動",
        "body": "準備好開始即可啟動。{{days}} 天期限將從首次啟動開始計算；機器使用時間從 工作區 就緒後才開始計算。",
        "reopenedBody": "作業已重新開放，就緒後即可啟動。截止時間為 {{deadline}}。"
      },
      "starting": {
        "title": "GPU 啟動中…",
        "body": "通常需要{{range}}。您可以離開此頁，就緒時我們可以寄信通知您。"
      },
      "booting": {
        "title": "Isaac Sim 啟動中…",
        "body": "機器已啟動，Isaac Sim 正在載入，通常需要 {{range}}。就緒前不扣機器使用時間。"
      },
      "running": {
        "title": "您的機器正在執行",
        "body": "離開時建議暫停，以節省機器使用時間。"
      },
      "grace": {
        "title": "機器使用時間已結束。",
        "body": "機器將在 {{mmss}} 後自動關機，請立即儲存您的工作。",
        "card": "請立即儲存您的工作。暫停與繼續已無法使用；倒數結束後機器將自動停止。",
        "startupCard": "您的使用時間已達上限。應用程式仍在啟動，就緒前無法存取。您可以立即結束。",
        "startupBody": "機器將在 {{mmss}} 後自動停止。最後倒數期間無法暫停。"
      },
      "stopping": {
        "title": "暫停中…",
        "body": "您的檔案會保留。在期限內可隨時繼續。"
      },
      "paused": {
        "title": "已暫停",
        "body": "機器使用時間未在計算。繼續約需{{range}}。"
      },
      "error": {
        "title": "發生問題",
        "body": "機器未能正常啟動，我們已收到通知。您可以再試一次。",
        "start_capacity": {
          "title": "目前沒有可用的 GPU",
          "body": "您的機器所在的雲端區域目前沒有空閒的 GPU。通常幾分鐘內會恢復，偶爾需要數小時。您的檔案安全無虞，機器使用時間也未在計算。"
        },
        "start_provider": {
          "title": "機器無法啟動",
          "body": "雲端供應商拒絕了啟動請求，我們已收到通知。請幾分鐘後再試一次。"
        },
        "start_timeout": {
          "title": "機器啟動時間過長",
          "body": "啟動請求已被接受，但機器在 15 分鐘內沒有啟動完成。我們已收到通知，您可以再試一次。"
        },
        "setup_failed": {
          "title": "工作區設定未完成",
          "body": "機器已啟動，但設定程序失敗。我們已收到通知；再試之前請先聯絡 HR。"
        }
      },
      "ended": {
        "title": "您的 session 已結束，感謝您。",
        "body": "您已使用 {{used}} / {{total}} 小時的機器使用時間。"
      },
      "endedReason": {
        "finished": "您已結束此 session。",
        "budget_exhausted": "您的機器使用時間已用完。",
        "window_expired": "您的作業時間限制已結束。",
        "revoked": "此 session 已由主辦方關閉。",
        "session_expired": "連續作答時間已結束。",
        "deadline_expired": "已到固定截止時間。"
      },
      "provisioning": {
        "title": "您的機器正在準備中",
        "body": "請稍後再回來查看。"
      },
      "preparing": {
        "title": "工作區準備中",
        "body": "初次準備完成後即可開始作答。目前尚未使用您的機器使用時間，也尚未開始計算作答期限。若準備作業暫停，請聯絡 HR。"
      },
      "workspaceStarting": {
        "title": "工作區啟動中…",
        "body": "機器已啟動，正在準備 VS Code，通常需要 {{range}}。工作區就緒後才開始計算 GPU 額度。"
      }
    },
    "actions": {
      "launch": "啟動",
      "pause": "暫停",
      "resume": "繼續",
      "finish": "結束",
      "finishNow": "立即結束",
      "retry": "再試一次",
      "working": "處理中…"
    },
    "confirm": {
      "launch": {
        "title": "要啟動機器嗎？",
        "body": "這將開始計算您的 {{days}} 天期限。您有 {{hours}} 小時的機器使用時間，僅在機器運行且 工作區 就緒時計算。",
        "ok": "啟動",
        "reopenedBody": "現在啟動工作區？截止時間維持 {{deadline}}。僅在機器運行且 工作區 就緒時計算機器使用時間。"
      },
      "pause": {
        "title": "要暫停機器嗎？",
        "body": "機器會停止，檔案會保留。繼續約需{{range}}。",
        "ok": "暫停",
        "startupBody": "要停止這次啟動嗎？檔案會保留，之後可以再繼續。目前未扣機器使用時間，但作業期限仍持續計算。"
      },
      "finish": {
        "title": "要結束 session 嗎？",
        "body": "結束後無法再繼續。機器會停止，session 將關閉。",
        "ok": "結束"
      }
    },
    "stepper": {
      "requesting_gpu": "申請 GPU",
      "booting": "開機",
      "starting_isaac": "啟動 Isaac Sim",
      "ready": "就緒",
      "elapsed": "已經過 {{time}}",
      "expected": "通常{{range}}",
      "starting_workspace": "啟動工作區"
    },
    "notify": {
      "label": "就緒時寄信通知我",
      "on": "機器就緒時我們會寄信給您。"
    },
    "access": {
      "title": "存取",
      "vscode": "開啟 VS Code",
      "viewer": "開啟 Isaac Sim 檢視器",
      "vscodePassword": "VS Code 密碼",
      "viewerUser": "檢視器帳號",
      "viewerPassword": "檢視器密碼",
      "oneTab": "一次只開一個檢視器分頁。開第二個會中斷第一個。",
      "troubleTitle": "連線有問題？",
      "trouble": {
        "udp": "檢視器透過 UDP 47998 埠傳送影像。部分公司或校園網路會封鎖它，改用手機熱點通常可行。",
        "refresh": "若檢視器畫面全黑，請等 Isaac Sim 載入完成後重新整理分頁一次。",
        "vscode": "VS Code 使用一般網頁連線，即使檢視器無法連線也能正常使用。",
        "hr": "仍有問題？請透過您既有的 HR 信件往來聯繫。"
      },
      "recordingNotice": "透過受管理的 OpenCode 傳送的提示詞與可見回覆，將依現有保留政策記錄，供授權的作業審查者檢視。此為部分紀錄，不包含內部推理、工具輸出與私人端點。"
    },
    "timeline": {
      "title": "活動紀錄",
      "empty": "尚無活動。",
      "launched": "已啟動",
      "paused": "已暫停",
      "resumed": "已繼續",
      "finished": "已結束",
      "notice_budget": "機器使用時間剩餘 {{hours}} 小時",
      "notice_budget_zero": "機器使用時間已用完",
      "notice_window": "距離截止還有 {{hours}} 小時",
      "grace_started": "10 分鐘關機倒數開始",
      "auto_paused": "已自動暫停",
      "extended_budget": "機器使用時間延長 {{minutes}} 分鐘",
      "extended_window": "期限延長 {{days}} 天",
      "error": "錯誤",
      "ready": "機器就緒",
      "auto_retry": "自動重試 #{{attempt}}"
    },
    "toast": {
      "budget": "機器使用時間剩餘 {{hours}} 小時",
      "budgetZero": "您的機器使用時間已結束。機器將在 10 分鐘後關機。",
      "window": "距離截止還有 {{hours}} 小時",
      "ready": "您的機器已就緒"
    },
    "used": "已使用 {{used}} 小時",
    "usedOf": "已使用 {{used}} / {{total}} 小時",
    "live": "狀態：{{state}}",
    "sessionEnded": "您的登入已失效，請重新開啟邀請連結。",
    "gpuPaused": "暫停",
    "startupActions": "暫停會取消這次啟動並保留檔案，之後可再繼續。結束會關閉作業，無法再繼續。啟動期間不扣機器使用時間，但作業期限仍持續計算。",
    "autoRetry": {
      "label": "自動重試",
      "on": "在截止時間允許的範圍內，我們會每隔幾分鐘重新請求機器，成功啟動後即停止。您可以離開此頁。",
      "off": "開啟後即使離開此頁，系統也會持續嘗試。"
    },
    "sessionLimit": "連續作答：從本次作答首次啟動起 {{minutes}} 分鐘，包含暫停時間。",
    "cutoffReached": "作業時間限制已到期，工作區存取權限已關閉。",
    "cutoffCleanup": "機器正在關閉中，此程序不會延長工作區存取權限。"
  },
  "expired": {
    "pageTitle": "Session 已結束",
    "window": {
      "title": "評測期限已結束",
      "body": "自首次啟動起的 5 天期限已經結束。感謝您的參與。"
    },
    "revoked": {
      "title": "此 session 已關閉",
      "body": "主辦方已關閉此 session。"
    },
    "session": {
      "title": "您已登出",
      "body": "請重新開啟 HR 提供的邀請連結以再次登入。"
    },
    "default": {
      "title": "此 session 已無法使用",
      "body": "感謝您的參與。"
    }
  },
  "dev": {
    "states": "狀態",
    "hint": "示範資料 · 無後端 · 僅開發用",
    "title": "候選人預覽",
    "admin": "管理後台預覽",
    "guide": "設計指南",
    "context": "目前工作流程：安全連結、自動準備，啟動期間暫停機器使用時間計時。此為範例資料，所有操作僅在預覽中生效。",
    "choose": "選擇情境",
    "action": "預覽：{{action}}",
    "localOnly": "此為操作示範，未開啟或變更實際工作區。",
    "signOut": "登出",
    "emails": "郵件設計",
    "overview": "功能預覽",
    "overviewHint": "使用範例資料檢查目前的測驗類型與 AI 狀態。變更僅留在此頁，重新整理後即會清除。",
    "gates": "僅供預覽。實際存取取決於伺服器授權、目前同意條款、有效作答階段、時間限制與剩餘額度。此頁不存取真實工作區、候選人帳號或 AI 供應商。",
    "kind": "測驗類型",
    "mode": "測驗狀態",
    "writtenTitle": "視覺抓取模組整合",
    "questionSample": "# 可靠的傳遞\n\n設計文件處理佇列，說明重複傳遞、重試與可見性逾時。\n\n## 您的方法\n\n說明取捨，並視需要提供虛擬程式碼。",
    "answerSample": "## 系統架構\n\n我會分開感知、抓取規劃與運動控制，為各階段建立明確的介面與安全檢查。",
    "writtenHint": "此範例可在本機編輯、自動儲存及提交；實際介面以修訂條件保護儲存，並保留不可變更的提交快照。",
    "gpuHint": "僅提供 VS Code · AWS g6e.2xlarge · 任意區域 · 128 GB 磁碟。90 分鐘連續作答及較早的有效截止時間，與 GPU 使用時間分開計算。",
    "isaacHint": "VS Code 與 Isaac Sim 檢視器共用受保護工作區。機器停止時暫停 GPU 計時，連續作答與固定期限仍持續計時。",
    "gpuTitle": "GPU 程式作業",
    "isaacTitle": "Isaac Sim 作業",
    "reset": "重設範例",
    "chatTitle": "AI 對話與存取狀態",
    "chatHint": "僅顯示模擬回覆。正式請求須使用允許且相容的模型，並符合零資料保留（ZDR）；BYOK 為選用。對話、用量與中斷回覆使用與候選人及管理員畫面相同的元件。",
    "chatSample": "每份工作使用**冪等鍵**，先提交結果，再確認訊息已傳遞。\n\n```typescript\nawait processOnce(job.id, job.payload);\n```",
    "aiState": "AI 存取狀態",
    "replyStatus": "已儲存的回覆狀態",
    "mockReply": "這是本機範例回覆，沒有任何資料傳送至 AI 供應商。",
    "mockSend": "傳送範例訊息",
    "toggleNotice": "切換就緒通知",
    "modes": {
      "active": "進行中",
      "finished": "已提交",
      "expired": "已到期"
    },
    "aiStates": {
      "enabled": "啟用範例",
      "ai_disabled": "AI 已停用",
      "ai_budget_exhausted": "額度用盡",
      "window_over": "時間已到",
      "accounting_pending": "等待結算"
    },
    "workspacePreview": "模擬預覽 · 返回預覽頁",
    "openWorkspace": "開啟完整作答介面預覽"
  },
  "feedback": {
    "pageTitle": "作業已完成",
    "finished": "感謝你的時間。工作區工作階段已結束，你可以隨時關閉此頁。",
    "title": "這次使用體驗如何？",
    "hint": "選填 · 歡迎分享從收到邀請到使用工作區的整體體驗。招募團隊可以閱讀你的回饋，請勿填寫密碼或其他敏感資訊。",
    "label": "你的回饋（選填）",
    "placeholder": "哪些部分順利？哪些地方可以更清楚或更方便？",
    "send": "送出回饋",
    "skip": "略過",
    "skipped": "已全部完成，你可以關閉此頁。",
    "thanks": "感謝你的回饋，你可以關閉此頁。",
    "error": "無法儲存或載入回饋，請再試一次。",
    "unavailable": "此工作階段已無法提交回饋。可以關閉此頁。",
    "loading": "正在載入選填回饋…",
    "retry": "再試一次"
  },
  "assessment": {
    "label": "書面作答",
    "answer": "答案",
    "question": "題目",
    "edit": "編輯",
    "preview": "預覽",
    "hide": "隱藏{{pane}}",
    "show": "顯示{{pane}}",
    "swap": "交換左右位置",
    "resize": "調整題目與答案區域大小",
    "panes": "作答區域",
    "empty": "尚無答案。",
    "count": "{{words}} 個詞 · {{chars}} 個字元",
    "copy": "複製答案",
    "submit": "提交答案",
    "submitTitle": "確定提交答案？",
    "submitBody": "系統會先儲存最新變更。提交後，本次作答將無法編輯，您可在 24 小時內查看已完成的答案。",
    "readOnly": "唯讀",
    "active": "作答中",
    "readOnlyHint": "本次作答已結束，已儲存答案為唯讀。尚未儲存的本機文字仍可複製。",
    "saving": "儲存中…",
    "unsaved": "尚未儲存的變更",
    "saved": "已於 {{time}} 儲存",
    "ready": "停止輸入 2 秒或離開編輯器時會自動儲存。按 Ctrl/⌘ + S 立即儲存。",
    "tooLarge": "答案超過 200 KB 上限，請縮短內容後儲存。",
    "conflict": "已儲存的版本已變更。您的文字仍保留，請選擇如何繼續。",
    "conflictTitle": "處理版本衝突",
    "localVersion": "您的本機文字",
    "serverVersion": "目前儲存的文字",
    "keepLocal": "保留我的文字並重新儲存",
    "useServer": "使用已儲存版本",
    "questionChanged": "題目已更新，請在儲存或提交前確認新題目。",
    "attemptChanged": "本次作答已被新階段取代。請先複製未儲存文字，再重新開啟邀請。",
    "locked": "此工作階段已無法儲存。請複製未儲存文字並確認邀請狀態。",
    "saveError": "無法儲存。您的文字仍在此處，請在離開前重試。",
    "submitError": "尚未確認提交成功。請重試以確認或完成同一份提交。",
    "retrySave": "重試儲存",
    "openError": "無法開啟作答頁面。請重試或聯絡 HR。",
    "completedUnavailable": "已完成答案的存取期限已過，或目前無法使用。",
    "intro": "請在瀏覽器中閱讀題目並撰寫答案。同意條款後開啟作答頁面時，系統開始計時。",
    "workspace": "瀏覽器作答",
    "workspaceHelp": "不會建立 GPU 或虛擬機器。",
    "window": "從開啟作答起 {{days}} 天",
    "windowHelp": "作答期限、連續作答時間或固定截止時間中最早到期者，將結束編輯權限。",
    "submission": "在此提交答案",
    "submissionHelp": "自動儲存會保留草稿，答案完成後請明確按下提交。",
    "sessionLimit": "連續作答時間：從開啟本次作答起 {{minutes}} 分鐘。",
    "savedLocally": "已儲存於此分頁 · 等待同步",
    "restored": "已從此分頁復原尚未同步的文字。請保持分頁開啟，直到伺服器儲存完成。"
  },
  "chat": {
    "title": "AI 對話",
    "open": "開啟 AI 對話",
    "back": "返回測驗",
    "privacy": "瀏覽器對話會儲存供測驗審查。請勿提供機密或無關的個人資料。AI 回覆可能不正確，請自行確認答案。",
    "loading": "載入對話中…",
    "unknown": "未知",
    "usage": "已用 {{used}}／{{limit}} · 剩餘 {{left}}",
    "unsettled": "部分請求尚待完成用量結算。",
    "priceHint": "回覆後可能需要一些時間更新用量。不同模型的費率各異。",
    "model": "新對話使用的模型",
    "modelHint": "建立新對話時可選擇任何可用的 ZDR 文字聊天模型；可用性取決於供應商及管理員的 BYOK 政策。",
    "new": "新增對話",
    "newTitle": "新對話",
    "conversations": "對話列表",
    "moreConversations": "更多對話",
    "rename": "重新命名對話",
    "empty": "建立對話即可開始。",
    "olderMessages": "載入較早的訊息",
    "historyError": "無法載入對話紀錄。",
    "streaming": "回覆中…",
    "stop": "停止回覆",
    "retry": "編輯後重試",
    "composer": "訊息",
    "composerHint": "按 Ctrl / ⌘ + Enter 傳送。每則訊息最多 64 KB。",
    "send": "傳送訊息",
    "copy": "複製訊息",
    "truncated": "此儲存訊息已截短。",
    "errors": {
      "ai_disabled": "此測驗未啟用 AI。",
      "ai_budget_exhausted": "AI 額度已用完。請聯絡測驗管理員。",
      "window_over": "測驗時間已結束，無法再使用 AI。",
      "consent_required": "請先同意目前的協議再使用 AI。",
      "assignment_not_active": "AI 僅於進行中的測驗開放。",
      "accounting_pending": "用量正在結算，請稍後重試。",
      "stale_attempt": "測驗次數已變更，請重新整理後繼續。",
      "conversation_busy": "此對話已有回覆正在產生中。",
      "rate_limited": "請求過於頻繁，請稍候再重試。",
      "incomplete_stream": "連線在回覆完成前中斷。請先確認已儲存的訊息，再決定是否重試。",
      "ai_unavailable": "AI 暫時無法使用。這不影響您的測驗答案。",
      "byok_verification_required": "此模型沒有符合管理員政策且已確認的 BYOK-only 路由，請選擇其他模型或聯絡管理員。",
      "catalog_unavailable": "目前無法確認最新 ZDR 模型目錄，請稍後重試。",
      "model_not_allowed": "此模型已不在相容的 ZDR 目錄，請使用其他模型建立對話。",
      "provider_unavailable": "目前無法取得所選供應商的回覆，請重試或選擇其他 ZDR 模型。"
    },
    "roles": {
      "user": "您",
      "assistant": "助理",
      "tool": "工具",
      "system_note": "系統備註"
    },
    "status": {
      "streaming": "回覆中",
      "complete": "完成",
      "error": "失敗",
      "aborted": "已停止",
      "incomplete": "未完成"
    },
    "updated": "更新時間 {{time}}"
  }
}
